// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const APP_RELOAD_APIDATA_FREQ = 300000; // 5 mins
export const SUBMITMODE_SAVEANDSTAY = 1;
export const SUBMITMODE_SAVEANDEXIT = 2;
export const SUBMITMODE_SAVEANDCONTINUETOEDIT = 3;
export const APP_INACTIVITY_TIMEOUT = 300000; // 5 mins
